const nasaReducer = (state, action) => {
  switch(action.type) {
    case 'SET_APOD':
      return {
        ...state,
        apod: action.payload,
        loading: false
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true
      }
    default:
      return state
    }
}

export default nasaReducer